import { SearchHeader } from "../search-header/index.client";
import { MainHeader, useMainHeader } from "../main-header/index.client";
import { useCallback, useState } from "react";
interface CustomerData {
  token_expires: string;
}

function useCustomerAuth(operations: { logout: () => void }) {
  return useCallback(() => {
    const hasLocalStorage = typeof localStorage !== 'undefined';
    const customerDataString = hasLocalStorage && localStorage.getItem("customer") || null;

    if (customerDataString) {
      try {
        const customerData = JSON.parse(customerDataString) as CustomerData;
        const tokenExpires = new Date(customerData.token_expires);
        const currentDate = new Date();

        if (tokenExpires <= currentDate) {
          hasLocalStorage && localStorage.removeItem("token");
          operations.logout();
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [operations.logout]);
}

function useResponsiveHeader() {
  const [showSearch, setShowSearch] = useState(false);
  const { operations } = useMainHeader();

  function toggleShowSearch () {
    document.body.style.overflow = "auto";
    setShowSearch((prev) => !prev);
  };

  const checkAuth = useCustomerAuth(operations);

  checkAuth();

  return {
    models: {
      showSearch,
    },
    operations: {
      toggleShowSearch,
    },
  };
}

export function ResponsiveHeader({ menu }: { menu: unknown }) {
  const { models, operations } = useResponsiveHeader();
  const { toggleShowSearch } = operations;

  if (models.showSearch) {
    return <SearchHeader closeSearch={toggleShowSearch} />;
  }
  return <MainHeader menu={menu} openSearch={toggleShowSearch} />;
}
